module.exports = __webpack_public_path__ + "img/FreelancerCircleTablet.5cdc7ad5.webp";